import { Link, useLocation } from "react-router-dom";

export default function PaymentCancelled() {
  const location = useLocation();
  const bookingId = new URLSearchParams(location.search).get("booking_id");
  return (
    <div data-testid="payment-cancelled-page" className="min-h-screen flex items-center justify-center px-5 py-20">
      <div className="border border-[#1F3325] bg-[#0F1712] p-10 max-w-lg text-center">
        <h2 className="font-display uppercase text-2xl text-[#F0F4F1]">Payment cancelled</h2>
        <p className="text-[#9CAEA3] mt-3">Your booking ({bookingId?.slice(0,8)}…) wasn't paid — so no contractor has been notified yet.</p>
        <div className="mt-7 flex gap-3 justify-center">
          <Link to="/book" className="btn-primary">Try again</Link>
          <Link to="/me/bookings" className="btn-secondary">My Bookings</Link>
        </div>
      </div>
    </div>
  );
}
